<template>
  <section class="recuiters-table">
    <div class="row-block">
      <h1>{{ $tr('analytics.recruiters.title') }}</h1>

      <vbutton
        label="analytics.recruiters.export"
        color="white"
        text_color="black"
        type="dropdown-dark"
        :loading="pendingSpinner"
        @click="getExportXLSX"
      />
    </div>

    <recruiters-list :table="recruitersTable" :filters-params="filtersParams" />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AnalyticsApi from '@/api/analytics.js';
import RecruitersList from './RecruitersList.vue';

export default {
  name: 'AnalyticsRecruitersTable',

  components: {
    RecruitersList
  },

  data() {
    return {
      pendingSpinner: false
    };
  },

  computed: {
    filtersParams() {
      let after, before;
      const f = this.$store.getters['analytics/filters'];
      if (f.createdAfter && f.createdAfter.format === undefined) {
        after = this.$moment(f.createdAfter);
      } else {
        after = f.createdAfter;
      }
      if (f.createdBefore && f.createdBefore.format === undefined) {
        before = this.$moment(f.createdBefore);
      } else {
        before = f.createdBefore;
      }
      return {
        vacancy_id: f.vacancy ? f.vacancy.id : null,
        created_after: f.createdAfter ? after.format('YYYY-MM-DD') : null,
        created_before: f.createdBefore ? before.format('YYYY-MM-DD') : null,
        user_email: f.user ? f.user.email : null
      };
    },

    ...mapGetters({
      recruitersTable: 'analytics/recruiters/recruitersTable',
      loading: 'analytics/recruiters/loading'
    })
  },

  async created() {
    await this.fetch(this.filtersParams);
  },

  methods: {
    ...mapActions('analytics/recruiters', ['fetch']),

    getExportXLSX() {
      this.pendingSpinner = !this.pendingSpinner;

      AnalyticsApi.exportRecruitersTableToExcel(this.filtersParams)
        .then(data => {
          this.pendingSpinner = false;
          window.location = data.url;
        })
        .catch(err => {
          this.$store.dispatch('global/setError', err);
          this.pendingSpinner = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.row-block {
  justify-content: space-between;
  margin-top: 48px;
  padding-bottom: 27px;

  h1 {
    margin: 0;
    font-weight: normal;
    line-height: 32px;
    font-size: 22px;
    letter-spacing: 0.005em;
    color: #233346;
    text-transform: none;
  }
}

.description {
  line-height: 22px;
  font-size: 16px;
  color: #7F7F7F;
  width: 60%;
  max-width: 600px;
  margin: 0;
}

.loading-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  width: 118px;
  height: 40px;
  cursor: not-allowed;
}
</style>
